class FourDotFivePhoneNumberController {
    /*@ngInject*/
    constructor($timeout) {
        this.$timeout = $timeout;
    }
    $onInit() {
        this.phoneNumberFormat = '+1 201-555-0123';
        if (_.isUndefined(this.elementId)) {
            this.elementId = "candidateContactPhoneNumber";
        }
        if (_.isUndefined(this.classes)) {
            this.classes = "";
        }
        if (_.isUndefined(this.defaultCountry)) {
            this.defaultCountry = "us";
        }
        if (_.isUndefined(this.disabledValue)) {
            this.disabledValue = false;
        }
        if (_.isUndefined(this.requiredValue)) {
            this.requiredValue = true;
        }
        this.$timeout(() => {
            if (!_.isNull(this.valueField) && !_.isUndefined(this.valueField)) {
                $('#' + this.elementId).intlTelInput("setNumber", this.valueField);
            }
            if (_.isNull(document.getElementById(this.elementId))) {
                this.phoneNumberFormat = "";
            }
            else {
                this.phoneNumberFormat = document.getElementById(this.elementId).placeholder;
            }
            // set up the handler for country change
            $('#' + this.elementId).on('countrychange', (e, countryData) => {
                this.$timeout(() => {
                    if (!_.isNull(this.valueField)) {
                        this.valueField = $('#' + this.elementId).intlTelInput("getNumber");
                        $('#' + this.elementId).intlTelInput("setNumber", this.valueField);
                    }
                    this.phoneNumberFormat = document.getElementById(this.elementId).placeholder;
                }, 100);
            });
        }, 300);
    }
    phoneNumberChanged() {
        this.$timeout(() => {
            this.valueField = $('#' + this.elementId).intlTelInput("getNumber");
            $('#' + this.elementId).intlTelInput("setNumber", this.valueField);
        }, 100);
    }
}
FourDotFivePhoneNumberController.$inject = ['$timeout'];
// import * as TEMPLATE from './four-dot-five-phone-number.html';
import * as TEMPLATE from 'raw-loader!./four-dot-five-phone-number.html';
export const FourDotFivePhoneNumberComponent = {
    selector: 'fourDotFivePhoneNumber',
    component: {
        bindings: {
            elementId: '@',
            classes: '@',
            defaultCountry: '@',
            valueField: '=',
            requiredValue: '=',
            disabledValue: '='
        },
        controller: FourDotFivePhoneNumberController,
        // templateUrl: 'app/shared/fourDotFivePhoneNumber/four-dot-five-phone-number.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=four-dot-five-phone-number.component.js.map